import { HTTPFunctions } from './types';

const error = ({ post }: HTTPFunctions) => ({
  saveError: (data: any) => post('/errors/frontend/', data),
});

export default error;
